const Container = ({ children, className }) => {
  return (
    <section className="">
      <div className={`w-[90%] mx-auto container ${className}`}>{children}</div>
    </section>
  );
};

export default Container;
